import { createTranslations } from '@npco/utils-translations'

export const freeTrialReviewTranslations = createTranslations({
  message:
    'Free for 60 days from the creation of your first Zeller Corporate Card, then only $9/month per card.',
})
